import { component } from "picoapp";
import React, { useEffect, useRef } from "react";
import ReactDOM from "react-dom";
import { createRoot } from "react-dom/client";
import { gsap } from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import "./component.scss";

function AnimatedHero() {
  const videoRef = useRef(null);

  useEffect(() => {
    const video = videoRef.current;

    gsap.registerPlugin(ScrollTrigger);

    video.addEventListener("loadedmetadata", () => {
      const videoDuration = video.duration;

      ScrollTrigger.create({
        trigger: ".shopify-section-animated-hero",
        start: "0",
        end: "100%",
        pin: true,
        scrub: 4,
        onUpdate: (self) => {
          if (videoRef.current) {
            const scrollPos = self.progress;
            const videoCurrentTime = videoDuration * scrollPos;
            videoRef.current.currentTime = videoCurrentTime;
          }
        },
      });
    });
  }, []);

  return (
    <div>
      <video
        src="https://cdn.shopify.com/videos/c/o/v/aac69e33555a4d5fb994d0d63d526dd2.mov"
        // src="https://cdn.shopify.com/videos/c/o/v/03bd851c8bb44187a6c962b1f59a024a.mov"
        playsinline="true"
        webkit-playsinline="true"
        preload="auto"
        muted="muted"
        className="video-background"
        ref={videoRef}
      ></video>
    </div>
  );
}

export default component((node, ctx) => {
  const element = <AnimatedHero node={node} ctx={ctx} />;
  const root = createRoot(node);
  root.render(element);

  return function () {
    try {
      ReactDOM.unmountComponentAtNode(node);
    } catch (e) {
      console.error(e);
    }
  };
});
